<template>
	<vs-popup
		:title="$t('returnToAuthorForRevision')"
		class="set-ticket-patch-mode"
		:active.sync="activeProp"
	>
		{{ $t('addCommentForAuthor') }}
		<vs-textarea v-model="commentForAuthor" rows="10"></vs-textarea>
		<div class="set-ticket-patch-mode__controls">
			<vs-button
				@click="confirm"
				color="warning"
			>{{ $t('forRevision') }}</vs-button>

			<vs-button
				@click="close"
				color="#9a9a9a"
				type="flat"
			>{{ $t('doCancel') }}</vs-button>
		</div>
	</vs-popup>
</template>

<script>
export default {
	name: "SetStagePatchModePopup",
	props: {
		active:				{ default: false, type: Boolean },
	},
	data() {
		return {
			commentForAuthor: '',
		}
	},
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},
	methods: {
		confirm() {
			this.$emit("confirm", this.commentForAuthor);

			this.activeProp = false;
		},
		close() {
			this.activeProp = false;
		}
	}
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-patch-mode {
	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $warning;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}

	.vs-input {
		width: 100%;
	}

	.vs-input--label {
		transition: color 0.3s ease;
	}

	.vs-input-primary.isFocus .vs-input--label {
		color: $warning;
	}

	.vs-input-primary .vs-input--input:focus {
		border-color: $warning !important;
	}
}
</style>
